/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetReceivedFollowRequestsQueryResponse,
  GetReceivedFollowRequests401,
} from "../types/GetReceivedFollowRequests.ts"
import { getReceivedFollowRequestsQueryResponseSchema } from "../zod/getReceivedFollowRequestsSchema.ts"

function getGetReceivedFollowRequestsUrl() {
  const res = { method: "GET", url: `/follow-requests/received` as const }
  return res
}

/**
 * @summary Get pending follow requests for the current user
 * {@link /follow-requests/received}
 */
export async function getReceivedFollowRequests(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReceivedFollowRequestsQueryResponse,
    ResponseErrorConfig<GetReceivedFollowRequests401>,
    unknown
  >({
    method: "GET",
    url: getGetReceivedFollowRequestsUrl().url.toString(),
    ...requestConfig,
  })
  return getReceivedFollowRequestsQueryResponseSchema.parse(res.data)
}
